//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PersonMilitaryService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[PersonMilitary.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/person-military/create', params || { });
	};

	//GeneratorFlag:[PersonMilitary.Delete]
	async delete(personMilitaryId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:personMilitaryId
		}
	
		return await _server.delete('/hub/person-military/delete', {'params':params})
	};

	//GeneratorFlag:[PersonMilitary.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-military/detail', {'params':params});
	};

	//GeneratorFlag:[PersonMilitary.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-military/list', {'params':params});
	};

	//GeneratorFlag:[PersonMilitary.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/person-military/update', params || { });
	};

//GeneratorFlag:[NewAction]
}